<div class="receive-card">
    <h2 class="subtitle" [innerHtml]="copyService.copies.receive_card_subtitle"></h2>

    <div class="row">
        <div class="col-4 col-pr-12 col-sm-8 col-md-12 col-lg-12 col-xl-12">
            <voxel-radio-button-group id="receiveCardList">
                <voxel-radio-button *ngFor="let receiveCard of listReceiveCard" [checked]="receiveCard.checked" (radioButtonChange)="selectradioShippingMethod(receiveCard)" [value]="receiveCard.elementId">
                    {{receiveCard.label}}
                </voxel-radio-button>
            </voxel-radio-button-group>
        </div>
    </div>
</div>
<app-controls id="receiveCardBtns" [hasPrevious]="true" [nextLabel]="copyService.copies.receive_card_button" [nextDisabled]="!stateButton" (next)="next()"></app-controls>